
<div class="ttmodal" id="schematicmasterWindow">
  <div id="schematicWindowHeader_" class="ttmodal__header">
    <span class="ttmodal__title">Schematic and Component Types</span>
    <a class="button waves-effect" (click)="onCloseClick()">
      <i class="material-icons button__icon">cancel</i>
      <span class="button__text">Close</span>
    </a>
  </div>

  <div class="ttmodal__body">
    <div style="display: flex; flex-direction: row; justify-content: space-between;">
      <div style="width: 40%; display: flex; flex-direction: column; margin-top: 2%; margin-bottom: 2%; gap: 10px; ">
        <div>
          <span>Schmatic Name</span>
          <input [(ngModel)]="schematicName" class="full-length">
        </div>
        <div>
          <mat-form-field class="header-form-full-width full-length" hasBackdrop="false">
            <span>Component Type(s)</span>
            <mat-select [formControl]="ComponentTypeVMForm" #matSelectCompType
                        multiple>
             <mat-option
                        *ngFor="let component of componentTypeList"
                        [value]="component.Id"
                        [disabled]="isComponentTypeDisabled(component.Id)">
                      
                        {{component.Name}}
                      
                        <span *ngIf="isComponentTypeDisabled(component.Id)">
                          ({{ getMappedSchematicName(component.Id) }})
                        </span>
                      
                      </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="end-text">
          <button mat-raised-button
                  color="warn"
                  [disabled]="loading"
                  [class.loading]="loading"
                  (click)="saveUpdateComponentType()">
            <i class="material-icons button__icon">save</i>
            <span class="button__text">Save</span>
          </button>
        </div>
        <div class="crack-container">
          <h3>Crack Display Options</h3>
          <div class="crack-row" *ngFor="let option of crackOptions">
            <span *ngIf="option.ColorCode" class="crack-color" [style.backgroundColor]="option.ColorCode"></span>
            <input type="checkbox" [(ngModel)]="option.isSelected" (change)="onCrackChange(option)" class="crack-checkbox" />
            <span class="crack-label">{{ option.CrackStatus }}</span>
          </div>
        </div>
      </div>
      <div style="width: 60%;">
        <div *ngIf="schematic != null" style="width: auto; height: auto; position: relative;">
          <img [src]="getImage(schematic.Data)" (click)="openSchematicAndObservationPointDetailsWindow()" style="width: 640px; height: 100%; cursor: pointer;">
          <ng-container *ngIf="schematic.ObservationPoints != null">
            <ng-container *ngFor="let cp of schematic.ObservationPoints">
              <i class="material-icons button__icon component-dot" *ngIf="cp.ObPointTypeId != 2 && cp.ObservationType != 'Crack'"
                 [class.green-eval]="getEval(cp.WornPct, cp.InspectionDate) == 'green'"
                 [class.yellow-eval]="getEval(cp.WornPct, cp.InspectionDate) == 'yellow'"
                 [class.orange-eval]="getEval(cp.WornPct, cp.InspectionDate) == 'orange'"
                 [class.red-eval]="getEval(cp.WornPct, cp.InspectionDate) == 'red'"
                 [class.no-eval]="getEval(cp.WornPct, cp.InspectionDate) == 'gray'"
                 [class.default]="getEval(cp.WornPct, cp.InspectionDate) == 'magenta'"
                 matTooltip="{{cp.Name}} ({{cp.WornPct}}% Worn) Last Inspection - {{cp.InspectionDate}} X,Y coord: {{cp.PositionX}},{{cp.PositionY}}"
                 [style]="getPosition(cp.PositionX, cp.PositionY)">lens</i>

              <div *ngIf="cp.EndPositionX!=null && cp.EndPositionX !=0  "
                   [class.yellow-eval]="getEval(cp.WornPct, cp.InspectionDate) == 'yellow'"
                   [matTooltip]="(cp.Name || '') + ' - Crack Date ' + (cp.InstallDate || '') + ' - Current Length ' + (cp.CurrentLength ?? '') + ' ' + (userUOM || '') +
                   (cp.CrackSeverity ? ' - Severity ' + cp.CrackSeverity : '') + ' - Crack Status ' + (cp.CrackStatus || '') + (cp.CrackStatusId === 1 ? '' : ' - (' + (cp.WornPct ?? '') + '% Worn)')"
                   [style]="getLine(cp.PositionX, cp.PositionY,cp.EndPositionX, cp.EndPositionY,cp.IsCrackFixed, cp)"></div>
            </ng-container>
          </ng-container>
        </div>
        <div class="sch-info">Click the image to add observation points or cracks</div>
      </div>
    </div>
  </div>
</div>